import React from "react";
import { Dialog, Slide, Backdrop, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Chip,
  Grid,
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Badge,
  Container,
  ThemeProvider,
  createTheme,
  CssBaseline,
} from "@mui/material";
const theme = createTheme({
  palette: {
    primary: {
      main: "#667eea",
    },
    secondary: {
      main: "#764ba2",
    },
    success: {
      main: "#10b981",
    },
    warning: {
      main: "#f59e0b",
    },
  },
  typography: {
    fontFamily: "Roboto, sans-serif",
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
          transition: "transform 0.2s ease-in-out",
          "&:hover": {
            transform: "translateY(-4px)",
          },
        },
      },
    },
  },
});
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
const ShowSupscriptionDetails = ({ subscription, open, onClose }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const getDaysRemaining = (endDate) => {
    const today = new Date();
    const end = new Date(endDate);
    const diffTime = end - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const daysRemaining = getDaysRemaining(subscription.end_date);

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={onClose}
      fullWidth
      maxWidth="xl"
      BackdropComponent={Backdrop}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0,0,0,0.5)",
          backdropFilter: "blur(4px)",
        },
      }}
      PaperProps={{
        style: {
          marginTop: "10vh",
          borderRadius: "16px",
          width: "1000px",
          padding: "20px",
          border: "2px solid #ccc",
          overflow: "auto",
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 10,
          right: 10,
        }}
      >
        <CloseIcon />
      </IconButton>
      <Typography
        variant="h3"
        component="h1"
        gutterBottom
        sx={{
          fontWeight: "bold",
          color: "white",

          mb: 4,
        }}
      >
        تفاصيل الاشتراك
      </Typography>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box
          sx={{
            minHeight: "100vh",
            /* background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", */
            py: 4,
          }}
        >
          <Container maxWidth="lg">
            {/* Header */}

            {/* Store Info & Status */}
            <Box container spacing={3} sx={{ mb: 4, display: "flex", gap: 2 }}>
              <Box item xs={12} md={4}>
                <Card
                  sx={{
                    background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                    color: "white",
                    textAlign: "center",
                    height: "100%",
                  }}
                >
                  <CardContent sx={{ p: 3 }}>
                    <Avatar
                      src={subscription.store.logo}
                      alt={subscription.store.name_en}
                      sx={{
                        width: 80,
                        height: 80,
                        mx: "auto",
                        mb: 2,
                        border: "3px solid rgba(255,255,255,0.3)",
                      }}
                    />
                    <Typography
                      variant="h5"
                      component="h2"
                      gutterBottom
                      sx={{ fontWeight: "bold" }}
                    >
                      {subscription.store.name_en}
                    </Typography>
                    <Typography variant="h6" sx={{ mb: 2, opacity: 0.9 }}>
                      {subscription.store.name_ar}
                    </Typography>

                    <Stack spacing={1} alignItems="center">
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <i className="material-icons" style={{ marginRight: 8, fontSize: 18 }}>
                          store
                        </i>
                        <Typography variant="body2">ID: {subscription.store.id}</Typography>
                      </Box>
                      <Typography variant="body2">{subscription.store.phone}</Typography>
                      <Typography variant="body2">{subscription.store.email}</Typography>
                    </Stack>
                  </CardContent>
                </Card>
              </Box>

              <Box item xs={12} md={8}>
                <Card sx={{ height: "100%" }}>
                  <CardContent sx={{ p: 3 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 3,
                      }}
                    >
                      <Typography variant="h5" sx={{
                        background:
                          "linear-gradient(90deg, #382a11, #6b5121, #9e7831, #d1a042)",
                        WebkitBackgroundClip: "text",
                        backgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        color: "transparent",
                        fontWeight: "bold",
                      }}>
                        حالة الاشتراك

                      </Typography>
                      <Chip
                        icon={<i className="material-icons"> {subscription.end_date > new Date() ? "check_circle" : "error"}</i>}
                        label={subscription.status.toUpperCase()}
                        color={subscription.end_date > new Date() ? "success" : "error"}
                        sx={{ fontWeight: "bold", color: "white" }}
                      />
                    </Box>

                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, bgcolor: "#f8fafc" }}>
                          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                            <i
                              className="material-icons"
                              style={{ marginRight: 8, color: "#4a5568" }}
                            >
                              event
                            </i>
                            <Typography variant="body2" color="text.secondary">
                              تاريخ البدء
                            </Typography>
                          </Box>
                          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                            {formatDate(subscription.start_date)}
                          </Typography>
                        </Paper>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, bgcolor: "#f8fafc" }}>
                          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                            <i
                              className="material-icons"
                              style={{ marginRight: 8, color: "#4a5568" }}
                            >
                              event_busy
                            </i>
                            <Typography variant="body2" color="text.secondary">
                              تاريخ الانتهاء
                            </Typography>
                          </Box>
                          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                            {formatDate(subscription.end_date)}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="warning.main"
                            sx={{ fontWeight: "bold" }}
                          >
                            {daysRemaining > 0 ? `${daysRemaining} days remaining` : "Expired"}
                          </Typography>
                        </Paper>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, bgcolor: "#f8fafc" }}>
                          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                            <i
                              className="material-icons"
                              style={{ marginRight: 8, color: "#4a5568" }}
                            >
                              autorenew
                            </i>
                            <Typography variant="body2" color="text.secondary">
                              تجديد تلقائي
                            </Typography>
                          </Box>
                          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                            {subscription.auto_renew ? "تم تفعيل" : "تم تعطيل"}
                          </Typography>
                        </Paper>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, bgcolor: "#f8fafc" }}>
                          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                            <i
                              className="material-icons"
                              style={{ marginRight: 8, color: "#4a5568" }}
                            >
                              confirmation_number
                            </i>
                            <Typography variant="body2" color="text.secondary">
                              رقم الاشتراك
                            </Typography>
                          </Box>
                          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                            #{subscription.id}
                          </Typography>
                        </Paper>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Box>
            </Box>

            {/* Plan Details */}
            <Card>
              <CardContent sx={{ p: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 3,
                  }}
                >
                  <Box>
                    <Typography variant="h5" sx={{
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      gap: 1
                    }}>
                      نوع الاشتراك:
                      <Chip
                        label={subscription.plan.name}
                        sx={{
                          background: "linear-gradient(135deg, #d1a042, #FDB931)",
                          color: "#111",
                          fontWeight: "bold",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                          fontSize: "1rem",
                          height: "32px"
                        }}
                      />
                    </Typography>
                    <Typography variant="h6" sx={{
                      fontWeight: "bold",
                      mt: 1,

                    }}>
                      ${subscription.plan.price}
                      <Typography component="span" variant="h6" color="text.secondary" sx={{ ml: 0.5 }}>
                        /{subscription.plan.billing_cycle == "monthly" ? "شهر" : "سنة"}
                      </Typography>
                    </Typography>
                  </Box>

                </Box>

                <Divider sx={{ my: 2 }} />

                <Grid container spacing={3}>
                  {/* Plan Limits */}
                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="h6"
                      gutterBottom
                      sx={{ fontWeight: "bold", color: "#d1a042" }}
                    >
                      حدود الخطة
                    </Typography>
                    <List dense>
                      <ListItem>
                        <ListItemIcon>
                          <i
                            className="material-icons"
                            style={{ color: "#111" }}
                          >
                            inventory
                          </i>
                        </ListItemIcon>
                        <ListItemText
                          primary="المنتجات"
                          secondary={`Up to ${subscription.plan.product_limit} products`}
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemIcon>
                          <i
                            className="material-icons"
                            style={{ color: "#111" }}
                          >
                            campaign
                          </i>
                        </ListItemIcon>
                        <ListItemText
                          primary="العروض"
                          secondary={`${subscription.plan.offers_limit} ${subscription.plan.offers_system} offers`}
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemIcon>
                          <i
                            className="material-icons"
                            style={{ color: "#111" }}
                          >
                            ads_click
                          </i>
                        </ListItemIcon>
                        <ListItemText
                          primary="الإعلانات"
                          secondary={`${subscription.plan.ads_limit} ${subscription.plan.ads_system} ads`}
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemIcon>
                          <i
                            className="material-icons"
                            style={{ color: "#111" }}
                          >
                            shopping_cart
                          </i>
                        </ListItemIcon>
                        <ListItemText
                          primary="الطلبات"
                          secondary={`Up to ${subscription.plan.orders_limit} orders`}
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemIcon>
                          <i
                            className="material-icons"
                            style={{ color: "#111" }}
                          >
                            people
                          </i>
                        </ListItemIcon>
                        <ListItemText
                          primary="المستخدمين"
                          secondary={`Up to ${subscription.plan.users_limit} users`}
                        />
                      </ListItem>
                    </List>
                  </Grid>

                  {/* Services */}
                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="h6"
                      gutterBottom
                      sx={{ fontWeight: "bold", color: "#d1a042" }}
                    >
                      الخدمات المتاحة
                    </Typography>

                    <Box sx={{ mb: 2 }}>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <i
                          className="material-icons"
                          style={{ marginRight: 8, color: "#111" }}
                        >
                          local_shipping
                        </i>
                        شركات الشحن
                      </Typography>
                      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                        {subscription.plan.shipping_companies.map((company) => (
                          <Chip key={company} label={company} size="small" variant="outlined" />
                        ))}
                      </Stack>
                    </Box>

                    <Box sx={{ mb: 2 }}>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <i
                          className="material-icons"
                          style={{ marginRight: 8, color: "#111" }}
                        >
                          payment
                        </i>
                        الطرق الدفع
                      </Typography>
                      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                        {subscription.plan.payment_gateways.map((gateway) => (
                          <Chip key={gateway} label={gateway} size="small" variant="outlined" />
                        ))}
                      </Stack>
                    </Box>

                    <Box sx={{ mb: 2 }}>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <i
                          className="material-icons"
                          style={{ marginRight: 8, color: "#111" }}
                        >
                          support_agent
                        </i>
                        الدعم الفني
                      </Typography>
                      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                        {subscription.plan.technical_support.map((support) => (
                          <Chip key={support} label={support} size="small" color="secondary" />
                        ))}
                      </Stack>
                    </Box>

                    <Box>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <i
                          className="material-icons"
                          style={{ marginRight: 8, color: "#111" }}
                        >
                          percent
                        </i>
                        Sales Commission: {subscription.plan.sales_commission}%
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        فترة الاختبار : {subscription.plan.trial_days} يوم
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Container>
        </Box>
      </ThemeProvider>
    </Dialog>
  );
};

export default ShowSupscriptionDetails;
